import { QueryState } from 'stores/types';

export const initialState: QueryState = {
  query: '',
  valueInput: '',
};
